module.exports = __webpack_public_path__ + "img/pink.efec9032.jpg";